module.exports = __webpack_public_path__ + "img/banner-subTitle.68ede54b.png";